import { handleResponse } from "utils/axios";
import { axiosInstance } from "./index";
import { onGet, onPost, onUpdateNote } from "mocksdata/unmatchedpayment";
/*Change Get Api here*/

const getApiUnmatchedPayment = async (query) => {
  onGet();
  if (query.status === "") {
    delete query.status;
  }
  return axiosInstance({
    method: "get",
    url: "unlinked-payments",
    params: query,
  }).then(handleResponse);
};

/*Change Post Api here*/
const postApiUnmatchedPaymentResolve = async (data) => {
  const { id, values } = data;
  onPost(id, values);
  return await axiosInstance.post(`unlinked-payments/${id}/resolve`, values).then(handleResponse);
};
const postApiUnmatchedPaymentNote = async (data) => {
  const { id, remark } = data;
  onUpdateNote(id, remark);
  return await axiosInstance
    .post(`unlinked-payments/${id}/remark`, { remark })
    .then(handleResponse);
};

/*Change Put Api here*/
const putApiUnmatchedPayment = async (id, data) => {
  return await axiosInstance.put("unlinked-payments", data).then(handleResponse);
};

/*Change Get Api here*/
const deleteApiUnmatchedPayment = async (id, data) => {
  return await axiosInstance.delete("unlinked-payments", data).then(handleResponse);
};

export {
  getApiUnmatchedPayment,
  postApiUnmatchedPaymentResolve,
  postApiUnmatchedPaymentNote,
  putApiUnmatchedPayment,
  deleteApiUnmatchedPayment,
};
